(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-toolbar"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.mobileToolbarCartCountReady) return;
    window.mobileToolbarCartCountReady = true;

    const setCartCount = (count) => {
      document.querySelectorAll('.t4s-toolbart-cart a').forEach((link) => {
        let badge = link.querySelector('.t4s-toolbar-count');
        if (count > 0) {
          if (!badge) {
            badge = document.createElement('span');
            badge.className = 't4s-toolbar-count';
            badge.setAttribute('aria-hidden', 'true');
            link.appendChild(badge);
          }
          badge.textContent = count < 100 ? count : '99+';
        } else if (badge) {
          badge.remove();
        }
      });
    };

    const refreshCartCount = () => {
      if (!window.routes || !window.routes.cart_url) return;
      fetch(`${window.routes.cart_url}.json`)
        .then((response) => response.json())
        .then((cart) => setCartCount(cart.item_count || 0))
        .catch(() => {});
    };

    const connect = () => {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, refreshCartCount);
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', connect, { once: true });
    } else {
      connect();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multicolumn_icon"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.multicolumnIconAutoplayReady) return;
    window.multicolumnIconAutoplayReady = true;

    const mediaQuery = window.matchMedia('(max-width: 749px)');

    const initAutoplay = (root = document) => {
      root.querySelectorAll('[data-multicolumn-icon-autoplay="true"]').forEach((component) => {
        if (component.dataset.multicolumnIconAutoplayInitialized === 'true') return;
        component.dataset.multicolumnIconAutoplayInitialized = 'true';

        const slider = component.querySelector('[id^="Slider-"]');
        const nextButton = component.querySelector('.slider-button--next');
        const speed = Math.max(parseInt(component.dataset.multicolumnIconAutoplaySpeed, 10) || 5000, 1000);
        let timer;

        if (!slider || !nextButton) return;

        const stop = () => {
          clearInterval(timer);
          timer = null;
        };

        const advance = () => {
          if (!mediaQuery.matches || document.hidden) return;

          if (nextButton.disabled) {
            slider.scrollTo({ left: 0, behavior: 'smooth' });
            return;
          }

          nextButton.click();
        };

        const start = () => {
          stop();
          if (!mediaQuery.matches || document.hidden) return;
          timer = setInterval(advance, speed);
        };

        const restart = () => {
          stop();
          window.setTimeout(start, speed);
        };

        component.addEventListener('pointerenter', stop);
        component.addEventListener('pointerleave', start);
        component.addEventListener('focusin', stop);
        component.addEventListener('focusout', start);
        component.addEventListener('touchstart', restart, { passive: true });
        component.addEventListener('click', restart);
        document.addEventListener('visibilitychange', start);

        if (mediaQuery.addEventListener) {
          mediaQuery.addEventListener('change', start);
        } else {
          mediaQuery.addListener(start);
        }

        start();
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAutoplay(), { once: true });
    } else {
      initAutoplay();
    }

    document.addEventListener('shopify:section:load', (event) => initAutoplay(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
